<div>
  <app-weee-system-filter
    (search)="searchWeeeSystems($event)">
  </app-weee-system-filter>
  <mat-divider></mat-divider>
  <app-weee-system-table *ngIf="weeeSystems"
    [countries]="countries"
    [weeeSystems]="weeeSystems.content"
    [pageSize]="weeeSystems.size"
    [totalElements]="weeeSystems.totalElements"
    (loadWeeeSystems)="loadWeeeSystems($event)"
    (updateWeeeSystemStatus)="updateWeeeSystemStatus($event)"
    (deleteWeeeSystem)="deleteWeeeSystem($event)">
  </app-weee-system-table>
</div>
